(() => {
  'use strict';

  function initProduct(page) {
    if (page.dataset.nProductReady === 'true') return;
    page.dataset.nProductReady = 'true';

    const slides = Array.from(page.querySelectorAll('[data-n-gallery-slide]'));
    const thumbs = Array.from(page.querySelectorAll('[data-n-gallery-thumb]'));
    const galleryStatus = page.querySelector('[data-n-gallery-status]');

    function showSlide(index) {
      if (!slides[index]) return;
      slides.forEach((slide, slideIndex) => { slide.hidden = slideIndex !== index; });
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-pressed', thumbIndex === index ? 'true' : 'false');
      });
      if (galleryStatus) galleryStatus.textContent = `Imagen ${index + 1} de ${slides.length}`;
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showSlide(index));
      thumb.addEventListener('keydown', (event) => {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % thumbs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index + thumbs.length - 1) % thumbs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = thumbs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        thumbs[nextIndex].focus();
        showSlide(nextIndex);
      });
    });

    const variantSelect = page.querySelector('[data-n-product-variants]');
    if (!variantSelect) return;

    const price = page.querySelector('[data-n-product-price]');
    const compare = page.querySelector('[data-n-product-compare]');
    const availability = page.querySelector('[data-n-product-availability]');
    const submit = page.querySelector('[data-n-product-submit]');
    const quantity = page.querySelector('[name="quantity"]');

    function syncVariant(updateUrl) {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      const currentPrice = Number(option.dataset.price);
      const comparePrice = Number(option.dataset.compare);
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.priceText || '';
      if (compare) {
        compare.hidden = !(comparePrice > currentPrice);
        compare.textContent = compare.hidden ? '' : (option.dataset.compareText || '');
      }
      if (availability) {
        availability.dataset.available = String(available);
        availability.textContent = available ? 'Disponible' : 'No disponible';
      }
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? 'Añadir al carrito' : 'No disponible';
      }
      if (quantity) {
        const min = Number(option.dataset.quantityMin) || 1;
        const step = Number(option.dataset.quantityStep) || 1;
        quantity.min = String(min);
        quantity.step = String(step);
        if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
        else quantity.removeAttribute('max');
        if (updateUrl || Number(quantity.value) < min) quantity.value = String(min);
      }

      if (option.dataset.imageId) {
        const imageIndex = slides.findIndex((slide) => slide.dataset.imageId === option.dataset.imageId);
        if (imageIndex >= 0) showSlide(imageIndex);
      } else if (updateUrl) {
        showSlide(0);
      }

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    variantSelect.addEventListener('change', () => syncVariant(true));
    syncVariant(false);
  }

  function initProducts(scope) {
    if (scope.matches?.('[data-n-product-page]')) initProduct(scope);
    scope.querySelectorAll('[data-n-product-page]').forEach(initProduct);
  }

  initProducts(document);
  document.addEventListener('shopify:section:load', (event) => initProducts(event.target));
})();
